var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SafetyVest50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#aeea00",
    d: "M33,6c-4.715,2.495-13.192,2.5-17.88,0.095l1.948,12.715V42H29.76V20.454L33,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6ff00",
    d: "M10,8.122v14.397c0,1.105-0.895,2-2,2h0c-1.105,0-2,0.895-2,2V41c0,0.552,0.448,1,1,1h12 c2.209,0,4-1.791,4-4V21.407L15.998,6.375c-0.213-0.458-0.734-0.685-1.215-0.529L10.692,7.17C10.279,7.304,10,7.688,10,8.122z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6ff00",
    d: "M38,8.122v14.397c0,1.105,0.895,2,2,2h0c1.105,0,2,0.895,2,2V41c0,0.552-0.448,1-1,1H29 c-2.209,0-4-1.791-4-4V21.407l7.002-15.032c0.213-0.458,0.734-0.685,1.215-0.529l4.092,1.325C37.721,7.304,38,7.688,38,8.122z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    x: 6,
    y: 29,
    fill: "#f5f5f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    x: 6,
    y: 35,
    fill: "#f5f5f5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    x: 25,
    y: 29,
    fill: "#f5f5f5",
    transform: "rotate(-180 33.5 30.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    x: 25,
    y: 35,
    fill: "#f5f5f5",
    transform: "rotate(-180 33.5 36.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SafetyVest50);
export default __webpack_public_path__ + "static/media/icons8-safety-vest-50.ae28b3fd64a5c73a106cbe65ab040b87.svg";
export { ForwardRef as ReactComponent };